import React from "react";
import { MDBContainer, MDBRow } from "mdbreact";
import 'mdbreact/dist/css/mdb.css'
import ServiceHoverSection from './serviceHoverSection'


const HoverGridService = () => {
    return (
        <section id="cardSection">
            <MDBRow className="m-0" center>
              <ServiceHoverSection />
            </MDBRow>
        </section>
    );
}

export default HoverGridService;
